import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxFieldWUT } from '../../../ui/checkbox-field';
export const ContactsSubscribeWUT = props => {
  const fieldType = FIELD_TYPES.CONTACTS_SUBSCRIBE;
  return /*#__PURE__*/React.createElement(CheckboxFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=contacts-subscribe-wut.js.map